import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;

  block-size: 100%;
  margin-block-start: 12px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
  }
`;

export const ThumbnailContainer = styled.div`
  inline-size: 117px;
  block-size: 117px;

  ${theme.breakpoints.down("tablet")} {
    inline-size: 287px;
    block-size: 47.33px;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    inline-size: 117px;
    block-size: 117px;

    ${theme.breakpoints.down("tablet")} {
      inline-size: 287px;
      block-size: 47.33px;
    }
  }
`;

export const Divider = styled.div`
  inline-size: 100%;
  block-size: 1px;
  block-size: 100%;
  margin-inline: 16px;
  border-inline-start: 1px solid rgba(0, 0, 0, 0.2);

  ${theme.breakpoints.down("tablet")} {
    display: none;
  }
`;
